var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames, useDir } from '@progress/kendo-react-common';
/**
 * Represents the [KendoReact BadgeContainer component]({% slug overview_badge %}).
 *
 * @example
 * ```jsx
 * const App = () => {
 *   return (
 *       <BadgeContainer>
 *           <Avatar shape="circle" type="image">
 *               <img src={'https://demos.telerik.com/kendo-ui/content/web/Customers/RICSU.jpg'} />
 *           </Avatar>
 *           <Badge cornerPlacement="edge" position="topEnd" shape="dot">
 *       </BadgeContainer>
 *   );
 * };
 *    ReactDOM.render(<App />, document.querySelector('my-app'));
 * ```
 */
export var BadgeContainer = React.forwardRef(function (props, target) {
    var children = props.children, className = props.className, style = props.style;
    var elementRef = React.useRef(null);
    var focusElement = React.useCallback(function () {
        if (elementRef.current) {
            elementRef.current.focus();
        }
    }, []);
    React.useImperativeHandle(target, function () { return ({
        element: elementRef.current,
        focus: focusElement
    }); });
    var dir = useDir(elementRef, props.dir);
    var containerClasses = React.useMemo(function () { return classNames('k-badge-container', className); }, [className]);
    var containerStyles = React.useMemo(function () { return (__assign({ display: 'inline-block' }, style)); }, [style]);
    return (React.createElement("span", { className: containerClasses, style: containerStyles, dir: dir }, children));
});
BadgeContainer.propTypes = {
    className: PropTypes.string,
    dir: PropTypes.string,
    style: PropTypes.object
};
BadgeContainer.displayName = 'KendoBadgeContainer';
//# sourceMappingURL=BadgeContainer.js.map